var Item = /*@__PURE__*/ (function () {
    function Item(element) {
        var _this = this;
        this.disableChangeHandle = function () {
            jQuery(_this.changeHandleElement).hide();
        };
        this.enableChangeHandle = function () {
            jQuery(_this.changeHandleElement).show();
        };
        this.activate = function () {
            _this.active = true;
            _this.getHead().addClass('tg-active');
            _this.getBody().show();
        };
        this.deactivate = function () {
            _this.active = false;
            _this.getHead().removeClass('tg-active');
            _this.getBody().hide();
        };
        this.enable = function () {
            _this.enabled = true;
            _this.getHead().removeClass('disabled');
        };
        this.disable = function () {
            _this.enabled = false;
            _this.getHead().addClass('disabled');
        };
        this.getElement = function () {
            return _this.element;
        };
        this.getHead = function () {
            return jQuery(_this.element).find('a.tg-head');
        };
        this.getBody = function () {
            return jQuery(_this.element).find('div.tg-body');
        };
        this.setComplete = function (completed) {
            _this.completed = completed;
            _this.renderHead();
        };
        this.renderHead = function () {
            if (_this.completed) {
                var stepIcon = Item.COMPLETED_STEP_ICON_HTML;
                jQuery(_this.element)
                    .find('.tg-head')
                    .find('[data-step-icon]')
                    .html(stepIcon);
                _this.enableChangeHandle();
            }
            else {
                var stepIcon = Item.STEP_ICON_HTML;
                stepIcon = stepIcon.replace('%s', _this.step.toString());
                jQuery(_this.element)
                    .find('.tg-head')
                    .find('[data-step-icon]')
                    .html(stepIcon);
                _this.disableChangeHandle();
            }
        };
        this.setLabel = function (label) {
            _this.label = label;
            _this.renderLabel();
        };
        this.renderLabel = function () {
            jQuery(_this.element)
                .find('.tg-head')
                .find('[data-label]')
                .html(_this.label);
        };
        this.registerEventListeners = function () {
            jQuery(_this.changeHandleElement).on('click', function () {
                _this.changeRequestEvt();
            });
        };
        this.onChangeRequest = function (callback) {
            _this.changeRequestEvt = callback;
        };
        this.element = element;
        this.active = false;
        this.enabled = false;
        this.completed = false;
        this.step = jQuery(this.element).index() + 1;
        this.changeHandleElement = jQuery(this.element).find('.tg-head [data-change-handle]').get(0);
        this.disableChangeHandle();
        this.registerEventListeners();
    }
    Item.STEP_ICON_HTML = "<div>\n        <span class=\"icon-wrap\">\n            <i class=\"i-step-number-b-xsml\">\n                <span class=\"step-number-digit\">%s</span>\n            </i>\n        </span>\n    </div>";
    Item.COMPLETED_STEP_ICON_HTML = "<svg class=\"i-xsml\">\n        <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/simplicity/svgdefs.svg#i-success-g-sml\">\n        </use>\n    </svg>";
    return Item;
}());
export default Item;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/plugins/RoamingStepper/Item.ts
// module id = null
// module chunks = 